import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import Button from "../components/common/Button";
import { IconPlus } from "../components/icons/Icons";

const EscritosPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    if (user !== null) {
      navigate("/escritos");
    }
    // getAudiencias();
  }, [user]);

  return (
    <>
      <TitleBox title="Relación de escritos" />
      <ContainerBox>
        <Button value="Nuevo" openModal={() => setIsModalOpen(true)}>
          <IconPlus className="w-4" />
        </Button>
        {/* <TableData columns={columns} data={audiencias} /> */}
      </ContainerBox>
    </>
  );
};

export default EscritosPage;
